// extracted by mini-css-extract-plugin
export default {"name":"Pack_name__b3BjU","disabledName":"Pack_disabledName__Tb1tf","emptyPack":"Pack_emptyPack__l7opn","title":"Pack_title__mEqSc","text":"Pack_text__kIxAB"};